/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint positive decision variants dictionary
 */
export enum FalconComplaintPositiveDecision {
  Refund = "K",
  Exchange = "W"
}
